import { throwError as observableThrowError } from "rxjs";

import { catchError, map } from "rxjs/operators";
import { ErrorHandler, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable()
export class GroupingService {
  hasError;
  errorMessage = "Sorry, we hit an error. Please try again later!";

  constructor(
    public http: HttpClient,
    private rollbarErrorHandler: ErrorHandler
  ) {}

  getCustomerGroupingByTemplateId(templateId) {
    let url = `${environment.kpiServiceApi}/groupings/templates/${templateId}?withResults=1`;
    return this.http
      .get(url, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  replaceGroupsOfCustomerGrouping(customerGroupingId, groups) {
    let url = `${environment.kpiServiceApi}/groupings/${customerGroupingId}/groups`;
    let body = groups;
    return this.http
      .put(url, body, { withCredentials: true })
      .pipe(catchError((err) => this.handleError(err)));
  }

  handleError(error) {
    console.error("error status: " + error.status);
    this.rollbarErrorHandler.handleError(error);
    return observableThrowError(error.status);
  }

  showError(message = "Sorry, we hit an error. Please try again later!") {
    this.errorMessage = message;
    this.hasError = true;
  }

  hideError() {
    this.hasError = false;
  }
}
